import React, { Component } from 'react'
import mojs from 'mo-js'
import Typist from 'react-typist'
// import cn from 'classnames'
// import logo from './logo.svg'


class Burst extends Component {
  render() {
    return (<div></div>);
  }
  
  shouldComponentUpdate () {
    this.props.isPlay && this._burst.replay();
    return false;
  }
  
  componentDidMount () {


    function viewport() {
      var e = window,
          a = 'inner';
      if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
      }
      return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
      }
    }

    var width = viewport().width,
        height = viewport().height;

    var radiusX = width / 7;
    var radiusY = height / 7;

    console.log(height)
    console.log(radiusY)

    const dur = 3500;

    const colors = [
      ['002a54', '002a54', '00315c', '013861', '093e68', '18456f', '264d76'],
      ['002a54', '01305a', '013861', '093e68', '18456f', '264d76', '30567d'],
      ['01305a', '033860', '093e68', '18456f', '264d76', '2f557c', '3b5c85'],
      ['013861', '093e68', '1b476e', '254a76', '30567d', '3b5c85', '46668c'],
      ['093e68', '16456f', '254c73', '2f5480', '3b5c85', '46668c', '536f94'],
      ['18456f', '264d76', '30567d', '3b5c85', '46668c', '526e93', '5d779a'],
      ['264d76', '30567d', '3b5c85', '46668c', '536f94', '5e789b', '5d779a'],
    ]

    class Ttt extends mojs.CustomShape {
      getShape() { return `<path d="M91.4,67.5c-4.6,0-6.2-1.5-6.2-8.2l-0.1-35.7l7.1,0l0-4.8l-7.1,0L85,0L67.9,2.4l0.1,16.4l-3.8,0l0,4.8    l3.8,0L68,57.1l-0.1,0c-0.5,6-4.2,10.5-8.8,10.5c-4.6,0-6.2-1.5-6.2-8.2l-0.1-35.7l7.3,0l0-4.8l-7.3,0L52.7,0.1L35.6,2.5L35.6,19    l-3.8,0l0,4.8l3.8,0l0.1,33.5h0c-0.5,6-3.8,10.5-8.4,10.5c-4.6,0-6.2-1.5-6.2-8.2L21,23.8l7.3,0l0-4.8L21,19L20.9,0.2L3.8,2.6    l0.1,16.4l-3.8,0l0,4.8l3.8,0l0.1,37.1C4,72,8.3,79.4,20.6,79.3c4.7,0,11.9-1.4,16.5-9.7c2,6,6.7,9.7,15.3,9.6    c4.8,0,12.2-1.5,16.8-10.3c1.9,6.3,6.6,10.2,15.5,10.2c5.8,0,10.2-3.5,10.2-10c0-0.8,0-1.7-0.1-2.5C94.2,67,93.2,67.5,91.4,67.5z"/>`; }
     getLength () { return 661.479248046875; }
    }
    mojs.addShape( 'Ttt', Ttt );
    class Management extends mojs.CustomShape {
      getShape() { return `<path d="M91,55.5l-0.1-37.1C90.9,7.3,86.6,0,74.3,0c-4.7,0-11.9,1.4-16.5,9.7c-2-6-6.7-9.7-15.3-9.6    c-4.8,0-12.2,1.5-16.8,10.3C23.8,4.1,19.1,0.2,10.2,0.2C4.4,0.2,0,3.7,0,10.3c0,0.8,0,1.7,0.1,2.5c0.6-0.5,1.5-1,3.3-1    c4.6,0,6.2,1.5,6.2,8.2l0.1,35.7l-7.1,0l0,4.8l7.1,0l0.1,18.8L27,76.9L27,60.4l3.8,0l0-4.8l-3.8,0l-0.1-33.5l0,0    c0.5-6,4.2-10.5,8.9-10.5c4.6,0,6.2,1.5,6.2,8.2l0.1,35.7l-7.3,0l0,4.8l7.3,0l0.1,18.8l17.1-2.4l-0.1-16.4l3.8,0l0-4.8l-3.8,0    l-0.1-33.5c0.5-6,3.8-10.5,8.4-10.5c4.6,0,6.2,1.5,6.2,8.2l0.1,35.7l-7.3,0l0,4.8l7.3,0L74,79.1l17.1-2.4l-0.1-16.4l3.8,0l0-4.8    L91,55.5z"/>`; }
     getLength () { return 660.919921875; }
    }
    mojs.addShape( 'Management', Management );
    


    class LogoSubTitle extends mojs.CustomShape {
      getShape() { return `<path d="M1.6 1.3H0V0.1h4.5v1.3H2.9v8.1H1.6V1.3 M9.8 0.1h1.1L13 9.5h-1.3l-0.4-2H9.4L9 9.5H7.7L9.8 0.1  M10.4 2.8L10.4 2.8L9.7 6.2H11L10.4 2.8 M17.7 0.1H19v8.1h2.7v1.3h-4V0.1 M26.5 0.1h1.3v4.3h0l2-4.3h1.3l-1.8 3.8l2.2 5.6h-1.4l-1.5-4.2l-0.7 1.4v2.8h-1.3V0.1 M43.4 1.3h-1.6V0.1h4.5v1.3h-1.6v8.1h-1.3V1.3 M50.7 2.3c0-1.5 1.2-2.3 2.3-2.3c1.1 0 2.3 0.8 2.3 2.3v5c0 1.5-1.2 2.3-2.3 2.3c-1.1 0-2.3-0.8-2.3-2.3    V2.3  M52 7.3c0 0.6 0.4 1 0.9 1s0.9-0.3 0.9-1v-5c0-0.6-0.4-1-0.9-1S52 1.7 52 2.3V7.3 M67.6 1.3h-1.6V0.1h4.5v1.3H69v8.1h-1.3V1.3 M75.1 0.1h1.3v4h1.7v-4h1.3v9.4h-1.3V5.3h-1.7v4.2h-1.3V0.1 M84.7 0.1h4v1.3h-2.7v2.8h2.3v1.3h-2.3v2.8h2.7v1.3h-4V0.1 M0.6 11.9h1.2l1.6 4.5h0l1.5-4.5h1.2v8.4H4.8v-5.1h0l-1.2 3.6H3l-1.2-3.6h0v5.1H0.6V11.9 M12.7 11.9h1l1.9 8.4h-1.2l-0.4-1.8h-1.6l-0.4 1.8h-1.2L12.7 11.9  M13.2 14.3L13.2 14.3l-0.6 3.1h1.2    L13.2 14.3 M20.4 11.9h1.2l1.8 5.1h0v-5.1h1.2v8.4h-1.1l-1.8-5.1h0v5.1h-1.2V11.9 M31.2 11.9h1l1.9 8.4h-1.2l-0.4-1.8h-1.6l-0.4 1.8h-1.2L31.2 11.9  M31.7 14.3L31.7 14.3l-0.6 3.1h1.2    L31.7 14.3 M38.8 13.9c0-1.4 1-2.1 2-2.1c1 0 2 0.7 2 2.1v0.4h-1.2v-0.4c0-0.6-0.4-0.9-0.8-0.9    c-0.4 0-0.8 0.3-0.8 0.9v4.5c0 0.6 0.4 0.9 0.8 0.9c0.4 0 0.8-0.3 0.8-0.9v-1.6h-1v-1.1h2.2v2.7c0 1.4-1 2.1-2 2.1    c-1 0-2-0.7-2-2.1V13.9 M48.2 11.9h3.6v1.1h-2.4v2.5h2.1v1.1h-2.1v2.5h2.4v1.2h-3.6V11.9 M56.7 11.9h1.2l1.6 4.5h0l1.5-4.5h1.2v8.4H61v-5.1h0l-1.2 3.6h-0.6L58 15.2h0v5.1h-1.2V11.9 M67.5 11.9h3.6v1.1h-2.4v2.5h2.1v1.1h-2.1v2.5h2.4v1.2h-3.6V11.9 M76.1 11.9h1.2L79 17h0v-5.1h1.2v8.4h-1.1l-1.8-5.1h0v5.1h-1.2V11.9 M86.4 13.1H85v-1.1h4v1.1h-1.4v7.3h-1.2V13.1z"/>`; }
     getLength () { return 691.1841430664062; }
    }
    mojs.addShape( 'LogoSubTitle', LogoSubTitle );






   
    var rects = []

    // var leftInterval = 100 / 7;


    for (var i = 0; i < 7; i++){
      for (var y = 0; y < 7; y++){
        rects.push(
          new mojs.Shape({
            shape:      'rect',
            scale:      { 0 : 1 },
            radiusX:    (radiusX / 2),
            radiusY:    (radiusY / 2),
            x:          i*radiusX - (width / 2) + (radiusX/2),
            y:          y*radiusY - (height / 2) + (radiusY/2),
            fill:       '#' + colors[i][y],
            duration:   1000,
            delay:      (i*100) + (y*50),
            easing:     'cubic.out',
            repeat:     0,
            
          })
          .then({
            x:          {to : i*40 - 120},
            y:          {to : y*40 - 160},
            radiusX:    {to : 20},
            radiusY:    {to : 20},
            duration:   1000,
            delay:      0,
            angle:      { to: 'rand(0, 360)' }
          })
          .then({
            delay:      1000,
            duration:   1000,
            angle:      { to: 0 }
          })

        )

      }
    }

    const logoTtt = new mojs.Shape({
      shape:        'Ttt',
      opacity:      { 0 : 1 },
      radius:       50,
      x:            -47,
      y:            90 - 160,
      fill:         '#FFF',
      duration:      1000,
      delay:         3300,
      easing:        'cubic.out',
      repeat:        0,
      scale:         1
    })

    const logoM = new mojs.Shape({
      shape:        'Management',
      opacity:      { 0 : 1 },
      radius:       50,
      x:            49,
      y:            90 - 160,
      fill:          '#FFF',
      duration:      1000,
      delay:         3400,
      easing:        'cubic.out',
      repeat:        0,
      scale:         1
    })

    const logoLine = new mojs.Shape({
      shape:        'rect',
      opacity:      { 0 : 1 },
      radiusX:      94,
      radiusY:      2,
      x:            -2,
      y:            138 - 160,
      fill:         '#FFF',
      duration:      1000,
      delay:         3500,
      easing:        'cubic.out',
      repeat:        0,
      scale:         1
    })

    const logoSubTitle = new mojs.Shape({
      shape:        'LogoSubTitle',
      opacity:      { 0 : 1 },
      radius:       100,
      x:            10,
      y:            250 - 160,
      fill:         '#FFF',
      duration:      1000,
      delay:         3600,
      easing:        'cubic.out',
      repeat:        0,
      scale:         1
    })

    rects.push(logoTtt, logoM, logoLine, logoSubTitle)


    this._burst = new mojs.Timeline()
    .add( rects);
    

  }    
}


class App extends Component {

  constructor (props, context) {
    super(props, context)
    this.state = {
        isPlay: true
    }

    this._play = this._play.bind(this)
    this._resetPlay = this._resetPlay.bind(this)

  }

  _play() { this.setState({ isPlay: true }); }
  _resetPlay() { this.setState({ isPlay: false }); }
  
  componentDidMount(){
    var that = this
    setTimeout(function(){ that.setState({ isPlay: true }) }, 1500);
    
  }                            
  render() {


    //    <a id="contact" href="/contact">Contact</a>
    return ( 

      <div id="wrapper">
        <Burst isPlay={this.state.isPlay} onComplete={this._resetPlay}/>
        
        <Typist 
          startDelay={5000} 
          cursor={{show: false, blink: true, element: '|', hideWhenDone: false, hideWhenDoneDelay: 1000}} 
          className="subtitle">
          'Music is the key to Success'
        </Typist>

        <div id="menu">
          <a href="/" className="menu-button button-1 active">Home</a>
          <a href="/who-we-are/" className="menu-button button-2">Who We Are</a>
          <a href="/contact/" className="menu-button button-3">Contact</a>
        </div>

        <div className="locations">
          <span className="loc loc-1">AMS</span>
          <span className="loc">-</span>
          <span className="loc loc-2">NYC</span>
          <span className="loc">-</span>
          <span className="loc loc-3">LA</span>
          <span className="loc">-</span>
          <span className="loc loc-4">LDN</span>
        </div>
      </div>
    );
  }

  // AMS - NYC - LA - LDN
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js